import { StreamingPlayerStylesFontFamily } from '@heardis/stream-contracts';
import { Helmet } from 'react-helmet';
import { useConfigContext } from '../../contexts/ConfigContext';
import { usePlayerContext } from '../../contexts/PlayerContext';

function getJoinedFontNames(fontFamilies: (StreamingPlayerStylesFontFamily)[]) {
  const uniqueFontFamilies = [...new Set(fontFamilies)];
  return uniqueFontFamilies
    ?.filter(Boolean)
    ?.map((fontFamily) => {
      const fontName = fontFamily.split(',')[0];
      const joinedFontName = fontName.replace(/\s/g, '+');
      return `family=${joinedFontName}`;
    })
    .join('&');
}

interface HeadProps {
  fontFamilies: StreamingPlayerStylesFontFamily[];
}

function Head({ fontFamilies }: HeadProps): JSX.Element {
  const { ui } = useConfigContext();
  const { currentTrack } = usePlayerContext();

  if (!ui) return <></>;
  /** @TOASK to use the page here like this is inconsistent, instead we can parse the seo stuff, because it isn't necessary in the widget? */
  const { page } = ui;
  const { description, title } = page.seo;
  const joinedFontNames = getJoinedFontNames(fontFamilies);

  return (
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      {joinedFontNames && <link href={`https://fonts.googleapis.com/css2?${joinedFontNames}:wght@400;700&display=swap`} rel="stylesheet" />}
      <title>{`${title}${currentTrack ? ` - ${currentTrack.track.title} by ${currentTrack.track.artist}` : ''}`}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
}

export default Head;
